import i18n from '@/i18n/i18n'

const { t } = i18n.global

export const DOCUMENT_PROCESS_TYPE_MAP = {
  PROMISSORY_NOTE: 0,
  CANCELLED_PROMISSORY_NOTE: 1,
  CONTROL_PROMISSORY_NOTE: 2,
  FARMER_IDENTITY_CARD: 3,
  INCOME_PROTECTED_SALE_CONTARCT: 4,
  UNKOWN: 5
}

export const DOCUMENT_PROCESS_TYPE = {
  0: t('constants.document_process_type.promissory_note'),
  1: t('constants.document_process_type.cancelled_promissory_note'),
  2: t('constants.document_process_type.control_promissory_note'),
  3: t('constants.document_process_type.farmer_identity_card'),
  4: t('constants.document_process_type.income_protected_sale_contract'),
  5: t('constants.document_process_type.unknown')
}
